import Component from 'classes/Component'

export default class Animation extends Component {
  constructor ({ element, elements }) {
    super({
      element,
      elements
    })
    this.createObserver()
    this.addEventListeners.bind(this)
    this.onResize()
  }

  createObserver () {
    this.observer = new window.IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (entry === Image) {
            entry.src = entry.getAttribute('data-src')
          }

          this.animateIn()

          if (this.element.getAttribute('data-animation') !== 'parallax') {
            this.observer.unobserve(this.element)
          }
        } else {
          this.animateOut()
        }
      })
    }, { threshold: 0 })

    this.observer.observe(this.element)
  }

  animateIn () {

  }

  animateOut () {

  }

  onResize () {

  }

  addEventListeners () {
    window.addEventListener('resize', this.onResize.bind(this))
  }
}
